"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionTreeNodeBox = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const react_1 = __importStar(require("react"));
const useFedActions_1 = __importDefault(require("../FedController/useFedActions"));
const useFedCnp_1 = __importDefault(require("../FedController/useFedCnp"));
const useFedSelect_1 = __importDefault(require("../FedController/useFedSelect"));
const makeMyClasses = (isSelected, isCopied, isBlank, disabled) => ({
    root: {
        display: 'flex',
        zIndex: 10,
        cursor: 'pointer',
        width: '100%',
        minWidth: 350,
        minHeight: 48,
        border: isCopied
            ? `2px solid ${lib_palette_1.default.positive.main}`
            : isSelected
                ? `2px solid ${lib_palette_1.default.secondary.main}`
                : `2px solid ${lib_palette_1.default.InputCardGrey.main}`,
        borderRadius: 4,
        backgroundColor: disabled
            ? lib_palette_1.default.BackgroundGrey.main
            : isSelected
                ? lib_palette_1.default.LightBlue.main
                : isBlank
                    ? lib_palette_1.default.BorderGrey.main
                    : lib_palette_1.default.White.main,
        alignItems: 'center',
        '&:hover': {
            borderColor: isCopied
                ? lib_palette_1.default.positive.light
                : isSelected
                    ? lib_palette_1.default.secondary.main
                    : lib_palette_1.default.PastelBlue.main,
        },
    },
});
function QuestionTreeNodeBox(props) {
    const { question, disabled, children } = props;
    const { selected } = (0, useFedSelect_1.default)();
    const { copied } = (0, useFedCnp_1.default)();
    const { doSelect } = (0, useFedActions_1.default)();
    const isSelected = selected === question.qId;
    const isCopied = copied === question.qId;
    const isBlank = question.title === '';
    const myCss = (0, web_css_1.default)(makeMyClasses, [isSelected, isCopied, isBlank, disabled]);
    const handleSelect = (0, react_1.useCallback)(() => {
        if (!isSelected)
            doSelect(question.qId);
    }, [isSelected, doSelect, question]);
    return (0, react_1.useMemo)(() => (react_1.default.createElement("div", { className: myCss.root + ' selectionContainer', onPointerDown: handleSelect }, children)), [myCss, handleSelect, children]);
}
exports.QuestionTreeNodeBox = QuestionTreeNodeBox;
exports.default = QuestionTreeNodeBox;
